"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextInput_1 = __importDefault(require("components/common/inputs/TextInput"));
var EditProductOptionBasic = function (_a) {
    var productOption = _a.productOption, onChange = _a.onChange;
    var keyTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        return function () { return clearTimeout(keyTimerRef.current); };
    }, []);
    var keyUpHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        clearTimeout(keyTimerRef.current);
        keyTimerRef.current = setTimeout(function () {
            onChange(name, value);
        }, 500);
    };
    return (react_1.default.createElement("div", { className: 'edit-product-spec-basic form' },
        react_1.default.createElement("span", { className: 'title' }, "Basic Information"),
        react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'name', placeholder: 'Specification Name', defaultValue: productOption.name, onKeyUp: keyUpHandler })));
};
exports.default = EditProductOptionBasic;
